import { memo } from 'react';

import GoogleSheetsIcon from '@/assets/google-sheets-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type GoogleSheetsLogoProps = LogoProps;

const IGoogleSheetsLogo = ({ className, ...rest }: GoogleSheetsLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <GoogleSheetsIcon className="size-5" />
    </Logo>
  );
};

export const GoogleSheetsLogo = memo(IGoogleSheetsLogo) as typeof IGoogleSheetsLogo;
